export const PapertrailUserTypes = {
  GUEST: "guest",
  OBBY: "obby",
  SYSTEM: "system",
  USER: "user"
} as const;
